import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from './core/servicios/auth.service';
import { LocalstorageService } from './core/servicios/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class GuardianGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private localstorageService: LocalstorageService,
    private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const tipo = this.authService.validar();

    if (tipo === 'Admin' || tipo === 'Empleado' || tipo === 'Tercero') {
      // Validacion local primero: revisar si la sesion tiene expiracion vigente
      const session = this.obtenerSesion(tipo);
      if (session && session.expiracion) {
        const expiracion = new Date(session.expiracion);
        const ahora = new Date();
        const minutosRestantes = (expiracion.getTime() - ahora.getTime()) / (1000 * 60);

        if (minutosRestantes > 30) {
          // Sesion vigente con mas de 30 min restantes: no consultar backend
          return true;
        }
      }

      // Sesion sin expiracion, cercana a expirar, o expirada: validar contra backend
      return this.authService.validarSesion().pipe(
        tap(valido => {
          if (!valido) {
            this.router.navigate(['/login']);
          }
        })
      );
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  private obtenerSesion(tipo: string): any {
    if (tipo === 'Admin') {
      return this.localstorageService.get('session_admin_com');
    } else if (tipo === 'Empleado') {
      return this.localstorageService.get('session_empleado_com');
    } else if (tipo === 'Tercero') {
      return this.localstorageService.get('session_tercero_com');
    }
    return null;
  }
}
